<template>
  <section class="members">
    <ims-item class="divider">Members</ims-item>
    <!-- Member Loop -->
    <ims-item
      v-for="(member, index) in members"
      :key="index"
      :class="`${index == members.length - 1 ? 'ims-item-last' : ''} pad`"
    >
      <!-- Name and Team -->
      <h1>
        {{ member.getMaskedEmail() }}<br />
        <small class="opacity-8 text-capitalize">{{ member.teamName }}</small>
      </h1>
      <!-- If Not Admin -->
      <p v-if="member.role != 'admin'" class="text-capitalize">
        <!-- Role and Status -->
        <span class="opacity-6">{{ member.role }} {{ member.status }}</span>
        <!-- Re-invite -->
        <button
          v-if="member.status == 'invited'"
          class="ml-2 btn btn-link text-xs p-0"
          @click="reInvite(member)"
        >
          Resend Invite
        </button>
      </p>
      <!-- Else If - they're commissioner -->
      <p v-else>Commissioner</p>
      <template v-slot:right>
        <ims-button
          v-if="member.role != 'admin'"
          type="clear"
          size="sm"
          color="red"
          @click="removeMember(member)"
          >Remove</ims-button
        >
      </template>
    </ims-item>
    <ims-item v-if="(members || []).length === 0" class="double ims-item-last">
      <div class="text-center ims-row justify-content-center">
        <ims-icon icon="face" class="mr-2" />No members found
      </div>
    </ims-item>
  </section>
</template>

<script>
export default {
  data() {
    return {
      members: []
    };
  },
  props: {
    id: {
      required: true
    },
    refresh: {
      type: Boolean
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    refresh: function() {
      this.init();
      // console.log('refreshed');
    }
  },
  methods: {
    async init() {
      try {
        this.members = await this.$User.service.getLeagueMembers(this.id);
        this.$store.dispatch('leagues/admin/setMembers', this.members);
      } catch (e) {
        this.$store.dispatch('interact/error', e.message);
      }
    },
    async doRemove(member) {
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Removing Member...'
      );
      try {
        let response = await this.$User.service.removeFromLeague(
          this.id,
          member
        );

        if (response) {
          this.$store.dispatch('interact/toast', {
            title: `${member.emailAddress} Removed`
          });
        }

        this.init();
      } catch (e) {
        this.$store.dispatch('interact/error', e.message);
      }

      closeLoader();
    },
    removeMember(member) {
      const self = this;
      this.$store.dispatch('interact/popmenu', {
        title: `Are you sure you want to remove ${member.getMaskedEmail()}?`,
        buttons: [
          {
            title: 'Remove Member',
            click() {
              self.doRemove(member);
            }
          }
        ]
      });
    },
    async reInvite(member) {
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Sending Invite...'
      );

      let response = await this.$User.service.inviteToLeague(
        member.emailAddress,
        this.id
      );
      if (response) {
        this.$store.dispatch('interact/toast', {
          title: `Invite sent to ${member.emailAddress}`
        });
      }
      closeLoader();
      this.init();
    }
  }
};
</script>
